// Тема витрины по design.md (монохром shadcn), с двумя отступлениями по просьбе
// владельца: тёмная инверсия по теме клиента и primary-акцент = цвет Telegram.
//
// Из клиента берём только два сигнала: светло/тёмно (colorScheme) и акцентный
// цвет (button_color). Всю монохромную гамму — канва/бумага/чернила/волосок —
// задаёт design.css фиксированными значениями; она не зависит от палитры клиента.
import './design.css';
import { tg, type TgThemeParams } from './tg';

/** "#5288c1" → "82 136 193", чтобы задавать прозрачность через rgb(… / %). */
function toRgbTriplet(hex: string): string | null {
  const m = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(hex.trim());
  if (!m) return null;
  let h = m[1];
  if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
  const n = parseInt(h, 16);
  return `${(n >> 16) & 255} ${(n >> 8) & 255} ${n & 255}`;
}

// Скин витрины: '1' — стандартный (акцент из Telegram), '2' — для магазина-моста.
// Палитру и вид блоков задаёт design.css по [data-market-theme]; здесь — только
// акцент, т.к. для темы 1 он динамический (из Telegram) и чистым CSS не берётся.
let marketTheme = '1';

// Дизайн 2 — агрессивный электрический кримсон на тёмном стекле. НЕ зависит от
// клиента: мост должен выглядеть иначе основного при любой теме.
const THEME2_ACCENT = '255 51 85'; // #FF3355
const THEME2_ACCENT_INK = '255 255 255';

function applyTheme(): void {
  const w = tg();
  const params: TgThemeParams = w?.themeParams ?? {};
  const root = document.documentElement;

  // Тёмная тема — по признаку клиента. Fallback — светлая (основной режим design.md).
  const dark = w?.colorScheme === 'dark';
  root.classList.toggle('tg-dark', dark);
  root.classList.add('tg-theme');
  root.style.setProperty('color-scheme', dark ? 'dark' : 'light');

  if (marketTheme === '2') {
    // Дизайн 2 — всегда тёмное стекло: тему клиента игнорируем.
    root.classList.add('tg-dark');
    root.style.setProperty('color-scheme', 'dark');
    root.style.setProperty('--accent', THEME2_ACCENT);
    root.style.setProperty('--accent-ink', THEME2_ACCENT_INK);
    return;
  }
  // Дизайн 1: единственная хроматика — акцент из темы Telegram (просьба владельца,
  // вместо чёрной primary из design.md). Нет клиента → синий Telegram.
  const accent = params.button_color ? toRgbTriplet(params.button_color) : null;
  const accentInk = params.button_text_color ? toRgbTriplet(params.button_text_color) : null;
  root.style.setProperty('--accent', accent ?? '36 129 204');
  root.style.setProperty('--accent-ink', accentInk ?? '255 255 255');
}

/** Ставит тему и следит за её сменой на лету. */
export function initTheme(): void {
  applyTheme();
  // Пользователь может переключить тему, не закрывая витрину.
  tg()?.onEvent('themeChanged', applyTheme);
  if (new URLSearchParams(location.search).has('debug')) showPalette();
}

/** Применяет скин витрины из конфига (после loadConfig). '2' — скин моста. */
export function applyMarketTheme(theme: string): void {
  marketTheme = theme === '2' ? '2' : '1';
  document.documentElement.dataset.marketTheme = marketTheme;
  applyTheme(); // пере-применить акцент под выбранный скин
}

/** `?debug=1` — показать применённые токены строкой внизу.
 *
 * В вебвью Telegram нет консоли, поэтому «тема не применилась» иначе не отличить
 * от «применилась, но выглядит похоже».
 */
function showPalette(): void {
  const cs = getComputedStyle(document.documentElement);
  const rows = ['--canvas', '--paper', '--ink', '--hairline', '--accent']
    .map((n) => `${n}: ${cs.getPropertyValue(n).trim() || '—'}`)
    .join('<br>');
  const box = document.createElement('div');
  box.style.cssText =
    'position:fixed;left:8px;right:8px;bottom:8px;z-index:99999;padding:10px 12px;' +
    'border-radius:10px;background:rgba(0,0,0,.82);color:#fff;font:11px/1.5 monospace;' +
    'white-space:pre-wrap;word-break:break-all';
  box.innerHTML =
    `<b>токены витрины</b> · класс: ${document.documentElement.className}<br>${rows}`;
  document.body.appendChild(box);
}
